import React from 'react';
import Addressmap from './oladdressmapview';
import DailyAddressmap from './dailytrips/DailyTripAddressMapview';
import Infra from './infraresults/addressinfraresultview';
import DailyTrips from './dailytrips/daily_trips_page';
//import Routemap from './react_components/livingplaceprocess/routemapview';
import LivingCostsView from './livingcostsview';
import LivingPlaceResultsView from './results/lp_results_page';
import { HashRouter, Route, Switch } from 'react-router-dom'

export default class LivingPlaceView extends React.Component {
	componentDidMount() {

	  }
	  render() {
		    return (
		    		<HashRouter>
				
				<Switch>
				<Route path={`${this.props.match.url}/:placeid/addressmap`} component={Addressmap}>
						</Route>
						<Route path={`${this.props.match.url}/:placeid/infrastruktur`} component={Infra}>
						</Route>
						<Route path={`${this.props.match.url}/:placeid/wohnkosten`} component={LivingCostsView}>
						</Route>
						<Route path={`${this.props.match.url}/:placeid/taeglichewege`} component={DailyTrips}>
						</Route>
						<Route path={`${this.props.match.url}/:placeid/waysmap`} component={DailyAddressmap}>
						</Route>
						<Route path={`${this.props.match.url}/:placeid/results`} component={LivingPlaceResultsView}>
						</Route>
				</Switch>				
				
				</HashRouter>
		    );
		  }
}



// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/livingplaceview.js